var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "赔付设置",
        visible: _vm.visible,
        width: "75%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center"
          },
          attrs: { slot: "title" },
          slot: "title"
        },
        [
          _c("span", [_vm._v(_vm._s(" "))]),
          _vm._v(" "),
          _c("span", [_vm._v("赔付设置")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "30px" },
              attrs: { size: "small" },
              on: { click: _vm.handleLog }
            },
            [_vm._v("日志")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.settings, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "setting-row" },
          [
            _c(
              "el-form",
              { attrs: { model: item, rules: _vm.rules, inline: "" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商品拿货价区间" } },
                  [
                    _c("el-input-number", {
                      staticClass: "price-input",
                      attrs: {
                        "controls-position": "right",
                        placeholder: "最小值",
                        min: 0,
                        max: item.max_price ? item.max_price - 1 : 9999999999,
                        precision: 2
                      },
                      on: {
                        change: function() {
                          return _vm.validateMinMax(item)
                        }
                      },
                      model: {
                        value: item.min_price,
                        callback: function($$v) {
                          _vm.$set(item, "min_price", $$v)
                        },
                        expression: "item.min_price"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "separator" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      staticClass: "price-input",
                      attrs: {
                        "controls-position": "right",
                        placeholder: "最大值",
                        min: item.min_price ? item.min_price + 1 : 0,
                        precision: 2
                      },
                      on: {
                        change: function() {
                          return _vm.validateMinMax(item)
                        }
                      },
                      model: {
                        value: item.max_price,
                        callback: function($$v) {
                          _vm.$set(item, "max_price", $$v)
                        },
                        expression: "item.max_price"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "超期赔付计算", required: "" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "calc-type",
                        model: {
                          value: item.overdue_type,
                          callback: function($$v) {
                            _vm.$set(item, "overdue_type", $$v)
                          },
                          expression: "item.overdue_type"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "按比例", value: "1" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "按绝对值", value: "2" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("el-input-number", {
                          staticClass: "calc-value",
                          attrs: {
                            "controls-position": "right",
                            min: 0,
                            precision: 2
                          },
                          model: {
                            value: item.overdue_value,
                            callback: function($$v) {
                              _vm.$set(item, "overdue_value", $$v)
                            },
                            expression: "item.overdue_value"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v(_vm._s(item.overdue_type === "1" ? "%" : "元"))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "断货赔付计算", required: "" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "calc-type",
                        model: {
                          value: item.stockout_type,
                          callback: function($$v) {
                            _vm.$set(item, "stockout_type", $$v)
                          },
                          expression: "item.stockout_type"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "按比例", value: "1" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "按绝对值", value: "2" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("el-input-number", {
                          staticClass: "calc-value",
                          attrs: {
                            "controls-position": "right",
                            min: 0,
                            precision: 2
                          },
                          model: {
                            value: item.stockout_value,
                            callback: function($$v) {
                              _vm.$set(item, "stockout_value", $$v)
                            },
                            expression: "item.stockout_value"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v(
                            _vm._s(item.stockout_type === "1" ? "%" : "元")
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                index !== 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.deleteRow(index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "setting-footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.settings.length >= 100 },
              on: { click: _vm.addRow }
            },
            [_vm._v("+ 添加设置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "赔付设置日志",
            visible: _vm.logVisible,
            width: "82%",
            "append-to-body": "",
            "modal-append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.logVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.logs, border: "", height: "450px" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "before",
                  label: "修改前",
                  "min-width": "530",
                  "header-align": "center",
                  align: "left"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(scope.row.old_setting) }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "after",
                  label: "修改后",
                  "min-width": "530",
                  "header-align": "center",
                  align: "left"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(scope.row.new_setting) }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "operator_name",
                  label: "操作人",
                  width: "80",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_date",
                  label: "操作时间",
                  width: "180",
                  align: "center"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pagination",
              staticStyle: { "margin-top": "20px", "text-align": "right" }
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.logPage,
                  "page-size": _vm.logPageSize,
                  total: _vm.logTotal,
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "size-change": _vm.handleLogSizeChange,
                  "current-change": _vm.handleLogCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcae5bbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcae5bbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchantClaimsOrder/components/CompensationSetting.vue
// module id = null
// module chunks = 